import { create } from "zustand";

const defaultConsent = {
  functional: true, // Siempre activas
  multimedia: false,
  analytics: false,
};

export const useConsentStore = create((set) => ({
  consent: null,
  setConsent: (consent) => {
    const full = { ...consent, functional: true };
    set({ consent: full });
    localStorage.setItem("cookieConsent", JSON.stringify(full));
  },
  rejectAll: () => {
    const rejected = { functional: true, multimedia: false, analytics: false };
    set({ consent: rejected });
    localStorage.setItem("cookieConsent", JSON.stringify(rejected));
  },
  acceptAll: () => {
    const accepted = { functional: true, multimedia: true, analytics: true };
    set({ consent: accepted });
    localStorage.setItem("cookieConsent", JSON.stringify(accepted));
  },
}));
